export default __webpack_public_path__ + "static/media/natureColoringSample.70999040d582413330e56c5cdaef8739.png";